export default __webpack_public_path__ + "static/Equity_logo_white-55d1991e5bf301a8d2d1d42a84039299.svg";